import React from 'react'
import { presenceSummary, initialsOf } from './presence.js'

/**
 * Initials chip on an inbox row for whoever else is on that ticket.
 * Hover for the full sentence; a pen marks a viewer with a draft open.
 */
function PresenceChip({ viewers }) {
  const summary = presenceSummary(viewers)
  if (!summary) return null
  return (
    <span
      className={`presence-chip${summary.composing ? ' presence-chip--composing' : ''}`}
      title={summary.label}
      aria-label={summary.label}
    >
      {initialsOf(summary.names[0])}
      {summary.composing && <span className="presence-chip__pen" aria-hidden="true">✎</span>}
    </span>
  )
}

export default PresenceChip
